import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { MasterDataService, MasterData } from './master.data.service';

@Injectable()
export class TermDepositInterestService {
  private baseApiUrl: string;
  private interestRateForList: Array<any>;

  constructor(configurationService: ConfigurationService,
    private masterDataService: MasterDataService,
    private masterData: MasterData,
    private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
    this.masterDataService.getAll([
      this.masterData.InterestRateFor
    ])
      .subscribe(data => {
        this.interestRateForList = data[0];
        console.log('Got data as ', data);
      },
        err => console.log('Get master data failed', err)
      );
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'termdepositinterest/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `termdepositinterest?isMaintenance=${forMaintenance}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `termdepositinterest/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(termDepositInterest: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositinterest', termDepositInterest).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(termDepositInterest: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'termdepositinterest', termDepositInterest).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositinterest/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `termdepositinterest/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getApplicableRate(schemeId: number, interestRateFor: number, periodInDays: number, amount: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `termdepositinterest/applicable/${schemeId}?interestRateFor=${interestRateFor}&&periodInDays=${periodInDays}&&amount=${amount}`)
      .pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getInterestRateForName(id: number): string {
    if (this.interestRateForList !== undefined) {
      return this.interestRateForList.find(list => list.id === id).name;
    }
  }
}
